"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = exports.default = void 0;
var _reduxActions = require("redux-actions");
var _TranslationsTypes = require("../actions/types/TranslationsTypes");
const defaultState = exports.defaultState = {};
var _default = exports.default = (0, _reduxActions.handleActions)({
  [_TranslationsTypes.SET_TRANSLATIONS]: (state, action) => {
    return {
      ...state,
      ...action.payload
    };
  }
}, defaultState);